import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  changePasswordResendOTPDetails: [],
  isLoading: false,
  error: "",
  hasData: false,
  codeStatus: "pending"
};
const crmChangePasswordOTPResendSlice = createSlice({
  name: "resendSection",
  initialState,
  reducers: {
    crmChangePasswordResendOTPPending: (state, action) => {
      state.isLoading = true;
      state.codeStatus = "pending";
    },
    crmChangePasswordResendOTPSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.changePasswordResendOTPDetails = action.payload;
      state.codeStatus = "success";
      sessionStorage.setItem("refNumber", action.payload.data.otpRefKey);
    },
    crmChangePasswordResendOTPFail: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.codeStatus = "failure";
      state.hasData = false;
    },
    crmChangePasswordResendOTPClear: state => {
      state.isLoading = false;
      state.error = "";
      state.hasData = false;
      state.changePasswordResendOTPDetails = [];
      state.codeStatus = "pending";
    }
  }
});
export const {
  crmChangePasswordResendOTPPending,
  crmChangePasswordResendOTPSuccess,
  crmChangePasswordResendOTPFail,
  crmChangePasswordResendOTPClear
} = crmChangePasswordOTPResendSlice.actions;
export default crmChangePasswordOTPResendSlice.reducer;